import React from 'react';

function MastercardCard(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="20" viewBox="0 0 32 20" {...props}>
      <rect fill="#252525" width="32" height="20" rx="2" />
      <g transform="translate(6, 3.75)">
        <circle fill="#EB001B" cx="6.25" cy="6.25" r="6.25" />
        <circle fill="#F79E1B" cx="13.75" cy="6.25" r="6.25" />
        <path
          d="M10,1.25 C11.5175,2.39 12.5,4.205 12.5,6.25 C12.5,8.295 11.5175,10.11 10,11.25 C8.4825,10.11 7.5,8.295 7.5,6.25 C7.5,4.205 8.4825,2.39 10,1.25 Z"
          fill="#FF5F00"
        />
      </g>
    </svg>
  );
}

export default MastercardCard;
